import React, { PureComponent } from 'react'
import { Layout, Menu, Icon } from 'antd'
import { Link } from 'react-router-dom'
import styles from './index.less'

const {Sider} = Layout
const {SubMenu} = Menu

/**
 * 获取图标
 * @param icon 图标名称 icon图标名称,img图片,图片组件
 * @return {*} 返回图标组件
 */
const getIcon = icon => {
  // 如果传入的参数为网址,则返回img组件
  if (typeof icon === 'string' && icon.indexOf('http') === 0) {
    return <img src={icon} alt="icon" className={`${styles.icon} sider-menu-item-img`}/>
  }
  // 如果传入的为字符串,不为网址则返回icon组件
  if (typeof icon === 'string') {
    return <Icon type={icon}/>
  }
  // 传入的为组件,直接返回
  return icon
}

export default class SiderMenu extends PureComponent {

  constructor (props) {
    super(props)
    this.menus = props.menuData
    this.state = {
      openKeys: this.getDefaultCollapsedSubMenus(props),
    }
  }

  componentWillReceiveProps (nextProps) {

  }

  /**
   * Convert pathname to openKeys
   * /list/search/articles = > ['list','/list/search']
   * @param  props
   */
  getDefaultCollapsedSubMenus (props) {
    // return getMenuMatchKeys(this.flatMenuKeys, urlToList(pathname))
  }

  /**
   * get SubMenu or Item
   */
  getSubMenuOrItem = item => {
    if (item.children && item.children.some(child => child.name)) {
      const childrenItems = this.getNavMenuItems(item.children)
      // 当无子菜单时就不展示菜单
      if (childrenItems && childrenItems.length > 0) {
        return (
          <SubMenu
            title={
              item.icon ? (
                <span>
                  {getIcon(item.icon)}
                  <span>{item.name}</span>
                </span>
              ) : (
                item.name
              )
            }
            key={item.path}
          >
            {childrenItems}
          </SubMenu>
        )
      }
      return null
    } else {
      return <Menu.Item key={item.path}>111</Menu.Item>
    }
  }

  /**
   * 获得菜单子节点
   * @memberof SiderMenu
   */
  getNavMenuItems = menusData => {
    if (!menusData) {
      return []
    }
    return menusData
      .filter(item => item.name && !item.hideInMenu)
      .map(item => {
        // make dom
        const ItemDom = this.getSubMenuOrItem(item)
        return this.checkPermissionItem(item.authority, ItemDom)
      })
      .filter(item => item)
  }
  // Get the currently selected menu
  getSelectedMenuKeys = () => {
    // const {location: {pathname}} = this.props
    // return getMenuMatchKeys(this.flatMenuKeys, urlToList(pathname))
  }

  // permission to check
  checkPermissionItem = (authority, ItemDom) => {
    if (this.props.Authorized && this.props.Authorized.check) {
      const {check} = this.props.Authorized
      return check(authority, ItemDom)
    }
    return ItemDom
  }

  isMainMenu = key => {
    return this.menus.some(item => key && (item.key === key || item.path === key))
  }

  handleOpenChange = openKeys => {
    const lastOpenKey = openKeys[openKeys.length - 1]
    const moreThanOne = openKeys.filter(openKey => this.isMainMenu(openKey)).length > 1
    this.setState({
      openKeys: moreThanOne ? [lastOpenKey] : [...openKeys],
    })
  }

  render () {
    const {collapsed, onCollapse} = this.props
    const {openKeys} = this.state
    // Don't show popup menu when it is been collapsed
    const menuProps = collapsed
      ? {}
      : {
        openKeys,
      }
    // if pathname can't match, use the nearest parent's key
    let selectedKeys = this.getSelectedMenuKeys()
    // if (!selectedKeys.length) {
    //   selectedKeys = [openKeys[openKeys.length - 1]]
    // }
    return (
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        breakpoint="lg"
        onCollapse={onCollapse}
        width={256}
        className={styles.sider}
      >
        <div className={styles.logo} key="logo">
          <Link to="/">
            <h1>金迈WBAP</h1>
          </Link>
        </div>
        <Menu
          key="Menu"
          theme="dark"
          mode="inline"
          {...menuProps}
          onOpenChange={this.handleOpenChange}
          selectedKeys={selectedKeys}
          style={{padding: '16px 0', width: '100%'}}
        >
          {this.getNavMenuItems(this.menus)}
        </Menu>
      </Sider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-main/components/SiderMenu/SiderMenu.js